module.exports = __webpack_public_path__ + "static/media/d15kz.5a9d3518.pdf";